import React from 'react';
import { Table, FormControl } from 'react-bootstrap';

import Translate from "../../../../utils/Translate"

class IncomeStatement extends React.Component {

	handleChange(field, value) {
		this.props.inputChanged("incomeStatement", field, value)
	}
handleNumericChange = (field, value) => {
		// Remove any non-digit characters except decimal point
		let numericValue = value.replace(/[^\d.]/g, '');
		
		// Remove leading zeros when typing, but allow zero as a value
		if (numericValue.startsWith('0') && numericValue.length > 1 && !numericValue.startsWith('0.')) {
			numericValue = numericValue.replace(/^0+/, '');
		}
		
		// If empty after cleaning, set to '0'
		if (numericValue === '') {
			numericValue = '0';
		}
		
		this.handleChange(field, numericValue);
	}
	render() {
		let grossProfit = 0
		grossProfit += (!isNaN(parseFloat(this.props.incomeStatement.salesRevenue))) ? parseFloat(this.props.incomeStatement.salesRevenue) : 0;
		grossProfit -= (!isNaN(parseFloat(this.props.incomeStatement.directCosts))) ? parseFloat(this.props.incomeStatement.directCosts) : 0;

		let totalOverhead = 0;
		totalOverhead += (!isNaN(parseFloat(this.props.incomeStatement.indirectRAndDCosts))) ? parseFloat(this.props.incomeStatement.indirectRAndDCosts) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.incomeStatement.docDevelopmentCosts))) ? parseFloat(this.props.incomeStatement.docDevelopmentCosts) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.incomeStatement.productionPlants))) ? parseFloat(this.props.incomeStatement.productionPlants) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.incomeStatement.machines))) ? parseFloat(this.props.incomeStatement.machines) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.incomeStatement.indirectProductionCosts))) ? parseFloat(this.props.incomeStatement.indirectProductionCosts) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.incomeStatement.marketing))) ? parseFloat(this.props.incomeStatement.marketing) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.incomeStatement.storageCosts))) ? parseFloat(this.props.incomeStatement.storageCosts) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.incomeStatement.indirectSalesCosts))) ? parseFloat(this.props.incomeStatement.indirectSalesCosts) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.incomeStatement.processOptimization))) ? parseFloat(this.props.incomeStatement.processOptimization) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.incomeStatement.qualityAssurance))) ? parseFloat(this.props.incomeStatement.qualityAssurance) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.incomeStatement.lease))) ? parseFloat(this.props.incomeStatement.lease) : 0;
		totalOverhead += (!isNaN(parseFloat(this.props.incomeStatement.otherOverheads))) ? parseFloat(this.props.incomeStatement.otherOverheads) : 0;

		const ebit = grossProfit - totalOverhead;

		let profitBeforeTax = ebit;
		profitBeforeTax += (!isNaN(parseFloat(this.props.incomeStatement.otherIncomes))) ? parseFloat(this.props.incomeStatement.otherIncomes) : 0;
		profitBeforeTax -= (!isNaN(parseFloat(this.props.incomeStatement.interest))) ? parseFloat(this.props.incomeStatement.interest) : 0;

		//let lossCarriedForward = parseFloat(this.props.incomeStatement.lossCarriedForward);
		const taxes = (!isNaN(parseFloat(this.props.incomeStatement.taxes))) ? parseFloat(this.props.incomeStatement.taxes) : 0;
		/*if (lossCarriedForward >= profitBeforeTax) {
			taxes = 0
		}else{
			taxes = Math.round(((profitBeforeTax - lossCarriedForward) * 0.25) / .5) * .5;
		}*/

		const profitAfterTaxes = profitBeforeTax - taxes;

		return (
			<Table bordered>
				<tbody>
					<tr>
						<td>
							<div className="bold">
								<Translate alias="Forms" word="Sales revenue" />
							</div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.salesRevenue }
								onChange={ (e) => this.handleNumericChange("salesRevenue", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Direct costs" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.directCosts }
								onChange={ (e) => this.handleNumericChange("directCosts", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr className="autofillFieldBackground">
						<td>
							<div className="bold"><Translate alias="Forms" word="Gross profit" /></div>
						</td>
						<td>
							<FormControl aria-label="Small" size="sm" value={ grossProfit } disabled />
						</td>
					</tr>
					<tr>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Indirect R&D costs" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.indirectRAndDCosts }
								onChange={ (e) => this.handleNumericChange("indirectRAndDCosts", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Depreciation of capitalized development costs" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.docDevelopmentCosts }
								onChange={ (e) => this.handleNumericChange("docDevelopmentCosts", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Depreciation of production plants" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.productionPlants }
								onChange={ (e) => this.handleNumericChange("productionPlants", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Depreciation of machines" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.machines }
								onChange={ (e) => this.handleNumericChange("machines", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Indirect production costs" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.indirectProductionCosts }
								onChange={ (e) => this.handleNumericChange("indirectProductionCosts", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Marketing" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.marketing }
								onChange={ (e) => this.handleNumericChange("marketing", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Storage costs" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.storageCosts }
								onChange={ (e) => this.handleNumericChange("storageCosts", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Indirect sales costs" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.indirectSalesCosts }
								onChange={ (e) => this.handleNumericChange("indirectSalesCosts", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Process optimization" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.processOptimization }
								onChange={ (e) => this.handleNumericChange("processOptimization", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Quality assurance" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.qualityAssurance }
								onChange={ (e) => this.handleNumericChange("qualityAssurance", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Lease" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.lease }
								onChange={ (e) => this.handleNumericChange("lease", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Other overheads" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.otherOverheads }
								onChange={ (e) => this.handleNumericChange("otherOverheads", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr className="autofillFieldBackground">
						<td>
							<div className="bold"><Translate alias="Forms" word="Total overheads" /></div>
						</td>
						<td>
							<FormControl aria-label="Small" size="sm" value={ totalOverhead } disabled />
						</td>
					</tr>
					<tr>
						<td></td>
						<td></td>
					</tr>
					<tr className="autofillFieldBackground">
						<td>
							<div className="bold"><Translate alias="Forms" word="Operating profit / EBIT" /></div>
						</td>
						<td>
							<FormControl aria-label="Small" size="sm" value={ ebit } disabled />
						</td>
					</tr>
					<tr>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Other incomes" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.otherIncomes }
								onChange={ (e) => this.handleNumericChange("otherIncomes", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Interest" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.interest }
								onChange={ (e) => this.handleNumericChange("interest", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr className="autofillFieldBackground">
						<td>
							<div className="bold"><Translate alias="Forms" word="Profit before tax" /></div>
						</td>
						<td>
							<FormControl aria-label="Small" size="sm" value={ profitBeforeTax } disabled />
						</td>
					</tr>
					<tr>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Loss carried forward" /></div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.lossCarriedForward }
								onChange={ (e) => this.handleNumericChange("lossCarriedForward", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr>
						<td>
							<div className="bold"><Translate alias="Forms" word="Taxes" /> 25%</div>
						</td>
						<td>
							<FormControl 
								aria-label="Small" 
								size="sm" 
								value={ this.props.incomeStatement.taxes } 
								onChange={ (e) => this.handleNumericChange("taxes", e.target.value )} 
								disabled={ !this.props.status }
							/>
						</td>
					</tr>
					<tr className="autofillFieldBackground">
						<td>
							<div className="bold">
								<Translate alias="Forms" word="Profit after tax" />
							</div>
						</td>
						<td>
							<FormControl aria-label="Small" size="sm" value={ profitAfterTaxes } disabled />
						</td>
					</tr>
				</tbody>
			</Table>
		);
	}

}

export default IncomeStatement;